<template>
  <div class="d-flex align-items-center pr-gd-half">
    <svg
      width="72"
      height="32"
      viewBox="0 0 72 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 2C0 0.895431 0.895431 0 2 0H70C71.1046 0 72 0.895431 72 2V30C72 31.1046 71.1046 32 70 32H2C0.895431 32 0 31.1046 0 30V2Z"
        fill="#F8F9FA"
      />
      <path
        d="M43.5 17.4062C43.4375 17.5938 43.3438 17.75 43.2188 17.8438C43.0938 17.9688 42.9375 18 42.7812 18H33.625L33.8125 19H42.2188C42.4375 19 42.625 19.0938 42.7812 19.2812C42.9062 19.4688 42.9688 19.6875 42.9375 19.9062L42.75 20.6875C43.0625 20.8438 43.2812 21.0625 43.4688 21.3438C43.6562 21.625 43.75 21.9375 43.75 22.25C43.75 22.75 43.5625 23.1562 43.2188 23.5C42.875 23.8438 42.4688 24 42 24C41.5 24 41.0938 23.8438 40.75 23.5C40.4062 23.1562 40.25 22.75 40.25 22.25C40.25 21.75 40.4062 21.3438 40.7812 21H34.2188C34.5625 21.3438 34.75 21.75 34.75 22.25C34.75 22.75 34.5625 23.1562 34.2188 23.5C33.875 23.8438 33.4688 24 33 24C32.5 24 32.0938 23.8438 31.75 23.5C31.4062 23.1562 31.25 22.75 31.25 22.25C31.25 21.9375 31.3125 21.6562 31.4688 21.375C31.625 21.125 31.8438 20.9062 32.125 20.7188L29.9375 10H27.75C27.5312 10 27.3438 9.9375 27.2188 9.78125C27.0625 9.65625 27 9.46875 27 9.25V8.75C27 8.5625 27.0625 8.375 27.2188 8.21875C27.3438 8.09375 27.5312 8 27.75 8H30.9688C31.125 8 31.2812 8.0625 31.4062 8.1875C31.5312 8.3125 31.625 8.4375 31.6875 8.59375L31.9688 10H44.25C44.5 10 44.6875 10.0938 44.8438 10.2812C44.9688 10.4688 45.0312 10.6875 44.9688 10.9062L43.5 17.4062Z"
        fill="#6E7881"
      />
    </svg>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
